import { MinusIcon, PlusIcon, ShoppingCartIcon } from "@heroicons/react/24/outline";
import { Button } from "./base/Button";
import { Card } from "./base/Card";
import { Img } from "./base/Img";
import { Title } from "./base/Title";
import { Input } from "./base/Input";
import { parseToCurrency, usePanier } from '../context/panier-context';
import { useUser } from '../context/user-context';
import { Produit } from "../services/apiProduits";

interface CardProduitProps {
  produit: Produit;
  className?: string;
}

export const CardProduit: React.FC<CardProduitProps> = ({
  produit,
  className
}) => {
  const { isAuthenticated } = useUser();
  const { panier, addToPanier, handleQuantityChange } = usePanier();

  const quantite = panier?.produits?.find((p) => p.id === produit.id)?.quantite ?? 0;
  const maxQteAtteinte = produit.stockDisponible === quantite;

  return (
    <Card className={`py-4 px-6 ${className} relative`}>
      {produit.stockDisponible === 0 &&
        <>
          <div className="corner-ribbon z-20 text-white text-sm font-semibold"
          >
            Rupture
          </div>
          <div className="absolute top-0 left-0 w-full h-full bg-gray-400 opacity-30 z-10 rounded-xl" />
        </>
      }
      <div className="relative">
        <Img
          src={produit.image_url ?? "/produits/ete-500.jpg"}
          alt={produit.libelle}
          width="w-[280px] md:w-[340px]"
          height="h-[260px] md:h-[320px]"
          fit="cover"
          filter="bg-secondary"
          opacity="opacity-20"

        />
        <div className="produit-description">
          <div className="flex flex-col rounded-md p-2 w-full">
            <Title type="h5" bold>{produit.libelle}</Title>
            <div>{produit.description}</div>
          </div>
        </div>
      </div>
      <div className="flex mt-4 justify-between">
        <div className="bg-primary-300 rounded-md p-2 font-bold">{parseToCurrency(produit.prix_num)}</div>
        {isAuthenticated && (
        <div className="flex gap-2">
          {quantite === 0
            ?
            <Button
              icon={<ShoppingCartIcon />}
              onClick={() => addToPanier(produit)}
              disabled={produit.stockDisponible === 0}
            >Ajouter</Button>
            :
            <>
              <Button
                icon={<MinusIcon />}
                aria-label={`-1 ${produit.libelle}`}
                onClick={() => handleQuantityChange(produit.id, quantite - 1, produit.stockDisponible)}
                disabled={produit.stockDisponible === 0}
              />
              <Input
                width={4}
                min={1}
                type='number'
                value={quantite}
                className='leading-none'
                max={produit.stockDisponible}
                onChange={e =>
                  handleQuantityChange(produit.id, Number(e.target.value), produit.stockDisponible)
                }
                disabled={produit.stockDisponible === 0} />
              <Button
                icon={<PlusIcon />}
                aria-label={`+1 ${produit.libelle}`}
                onClick={() => handleQuantityChange(produit.id, quantite + 1, produit.stockDisponible)}
                disabled={produit.stockDisponible === 0 || maxQteAtteinte}
                className={maxQteAtteinte ? '!bg-alert-400 !border-alert-400 opacity-90 cursor-not-allowed' : ''}
                title={maxQteAtteinte ? 'Plus de stock disponible !' : ''}
              />
            </>
          }
        </div>
        )}
      </div>
    </Card>
  )
}